module.exports = __webpack_public_path__ + "static/img/gen_3.cf9bb64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gen_3.png
// module id = j5Pq
// module chunks = 16